import { useState, useContext } from 'react';
import { signupService } from '../service/signupService.mjs';
import { AuthContext } from '../../../authProvider.mjs';
import { useNavigate } from 'react-router-dom';



export const useSignup = () => {
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [position, setPosition] = useState('');
    const [role, setRole] = useState('');
    const [region, setRegion] = useState('');
    const [error, setError] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    
    const { startVerificationProcess } = useContext(AuthContext);
    const navigate = useNavigate();
    
    const handleSubmitSignup = async (e) => {
        e.preventDefault();
        setError(null);
        setIsLoading(true);
        
        try {
            const response = await signupService({
                firstName,
                lastName,
                email,
                password,
                confirmPassword,
                role,
                region,
                position
            });
            
            // Start verification process (this will skip auth checks)
            startVerificationProcess();
            
            // Navigate to verification page with user data
            navigate('/verify-email', { 
                state: { 
                    email: response.email,
                    message: response.message
                }
            });
            
        } catch (err) {
            setError(err.message);
        } finally {
            setIsLoading(false);
        }
    };
    
    return {
        firstName,
        lastName,
        email,
        password,
        confirmPassword,
        role,
        region,
        setFirstName,
        setLastName,
        setEmail,
        setPassword,
        setConfirmPassword,
        setRole,
        setRegion,
        position, 
        setPosition,
        error,
        isLoading,
        handleSubmitSignup
    };
};


